export const addresses = [
    {
        city: 'Суми',
        address: 'проспект Перемоги, 26',
        href:'https://goo.gl/maps/xz7zBNGgNf1Deorp7',
        phone:'+38 (099) 446 44 20'
    },
    {
        city: 'Конотоп',
        address: 'Братів Лузанів, 1а',
        href: 'https://goo.gl/maps/gQmUPMnaarMSGQvK9',
        phone: '+38 (066) 577 53 01'
    },
    {
        city: 'Глухів',
        address: 'Путивльська, 140',
        href: 'https://goo.gl/maps/yibdnM14GVXSqHLd6',
        phone: '+38 (095) 752 13 15'
    },
    {
        city: 'Ямпіль',
        address: 'Спасо-Преображенська',
        href: 'https://goo.gl/maps/oZMyxTZHLm7au4gQ9',
        phone: '+38 (095) 341 52 96'
    },

]